import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useTheme } from 'styled-components';

export const HeaderButton: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const onAdd = () =>
    createGoalAllowed ? openCreateGoalDialog({}) : openPremiumDialog();

  return theme.isMobile ? null : (
    <Button
      onClick={onAdd}
      size={Sizes.Small}
      variant={Variants.Contained}
      color={Colors.Primary}
      startIcon={Plus}
      preventDrag
    >
      {t('pages.goals.header.add-goal')}
    </Button>
  );
};
